<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col lg="12" sm="12" class="form-for-textarea">
                    <b-overlay :show="unitLoad">
                    <b-table-simple striped bordered small>
                        <b-tr style="background-color: #66CC99; color: white">
                            <b-th>{{ $t('globalTrans.sl_no') }}</b-th>
                            <b-th>{{ $t('production_store.pro_category') }}</b-th>
                            <b-th>{{ $t('retailerManagement.product_name') }}</b-th>
                            <b-th>{{ $t('retailerManagement.unit') }}</b-th>
                            <b-th>{{ $t('retailerManagement.quantity') }}</b-th>
                            <b-th v-if="dataArray.rec_status !== 1">{{ $t('retailerManagement.received_quantity') }}</b-th>
                            <b-th>{{ $t('retailerManagement.unit_price') }}</b-th>
                            <b-th>{{ $t('retailerManagement.total_price') }}</b-th>
                        </b-tr>
                        <b-tr v-for="(item, index) in dataArray.delivery_details" :key="index">
                            <b-td>{{ $n(index + 1) }}</b-td>
                            <b-td>{{ getCategoryName(item.product_id) }}</b-td>
                            <b-td>{{ productNameById(item.product_id) }}</b-td>
                            <b-td>{{ unitNameById(item.unit_id) }}</b-td>
                            <b-td>{{ $n(item.quantity) }}</b-td>
                            <b-td v-if="dataArray.rec_status !== 1">{{ item.received_quantity }}</b-td>
                            <b-td>{{ $n(item.unit_price) }}</b-td>
                            <b-td>{{ $n(item.total_price) }}</b-td>
                        </b-tr>
                        <b-td v-if="dataArray.rec_status !== 1" colspan="7">
                            <p style="margin-left:85%">{{ $t('sales_distribution_admin.grand_price') }}</p>
                        </b-td>
                        <b-td v-else colspan="6">
                            <p style="margin-left:85%">{{ $t('sales_distribution_admin.grand_price') }}</p>
                        </b-td>
                        <b-td>{{ $n(parseFloat(sumTotal)) }}</b-td>
                    </b-table-simple>
                    </b-overlay>
                    <b-row>
                        <b-col lg="3" sm="12">
                            <b-form-group
                                class="row"
                                label-cols-sm="12"
                                label-for="delivery_date"
                            >
                                <template v-slot:label>
                                {{ $t('retailerManagement.delivery_date')}}
                                </template>
                                <b-form-input
                                readonly
                                placeholder="Select Date"
                                id="delivery_date"
                                v-model="dataArray.delivery_date"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col lg="3" sm="12">
                            <b-form-group
                                class="row"
                                label-cols-sm="12"
                                label-for="delivery_location"
                            >
                                <template v-slot:label>
                                {{ $t('retailerManagement.delivery_location')}}
                                </template>
                                <b-form-input
                                readonly
                                placeholder=""
                                id="delivery_location"
                                v-model="dataArray.delivery_location"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col lg="3" sm="12">
                            <b-form-group
                                class="row"
                                label-cols-sm="12"
                                label-for="contact_no"
                            >
                                <template v-slot:label>
                                {{ $t('retailerManagement.contact_no')}}
                                </template>
                                <b-form-input
                                readonly
                                placeholder=""
                                id="contact_no"
                                v-model="dataArray.contact_no"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col lg="3" sm="12">
                            <b-form-group
                                class="row"
                                label-cols-sm="12"
                                label-for="manual_bill_no"
                            >
                                <template v-slot:label>
                                {{ $t('retailerManagement.manual_bill_no')}}
                                </template>
                                <b-form-input
                                readonly
                                placeholder=""
                                id="manual_bill_no"
                                v-model="dataArray.manual_bill_no"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col lg="12" sm="12">
                            <label class="mr-4">{{ $t('production_store.comment')}}</label>
                            <span v-if="currentLocale == 'bn'">{{ dataArray.comment_bn }}</span>
                            <span v-else>{{ dataArray.comment }}</span>
                        </b-col>
                    </b-row>
                    <div class="row">
                    <div class="col-sm-3"></div>
                    <div class="col text-right">
                        <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-details')">{{ $t('globalTrans.cancel') }}</b-button>
                    </div>
                    </div>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { core } from '@/config/pluginInit'

export default {
  props: ['id'],
  components: {
  },
  data () {
    return {
      saveBtnName: this.$t('globalTrans.save'),
      dataArray: {
        delivery_type: 0,
        demmand_user_id: 0,
        delivery_date: '',
        delivery_location: '',
        contact_no: '',
        comments: '',
        comments_bn: ''
      },
      unitLoad: false,
      sumTotal: 0
    }
  },
  computed: {
    currentLocale: function () {
        return this.$i18n.locale
    },
    ...mapGetters({
        productCommonObj: 'ProductionService/commonObj'
    })
  },
  created () {
    if (this.id) {
      const tmp = this.getQuotationData()
      this.dataArray = tmp
      this.getGrandTotal()
    }
  },
  mounted () {
    core.index()
  },
  methods: {
    getCategoryName (Id) {
      const product = this.productCommonObj.productList.find(product => product.value === Id)
      if (typeof product !== 'undefined') {
        const Obj = this.productCommonObj.productCategoryList.find(el => el.value === product.category_id)
        return typeof Obj !== 'undefined' ? (this.$i18n.locale === 'en' ? Obj.text_en : Obj.text_bn) : ''
      }
      return ''
    },
    getGrandTotal () {
      let sumM = 0
      this.dataArray.delivery_details.forEach(function (data) {
        sumM = sumM + parseFloat(data.total_price)
      })
      this.sumTotal = parseFloat(sumM)
    },
    getQuotationData () {
      const tmpData = this.$store.state.list.find(item => item.id === this.id)
      const tmp = JSON.parse(JSON.stringify(tmpData))
      return Object.assign({}, tmp)
    },
    productNameById (id) {
        const product = this.productCommonObj.productList.find(product => product.value === id)
        if (this.$i18n.locale === 'bn') {
            return product.text_bn
        } else {
            return product.text_en
        }
    },
    unitNameById (id) {
      const unit = this.productCommonObj.productUnitList.find(unit => unit.value === id)
      if (this.$i18n.locale === 'bn') {
          return unit.text_bn
      } else {
          return unit.text_en
      }
    }
  }
}
</script>
